import React, { useState } from 'react';
import '../styles/main.scss';
import './LoginPage.scss';

interface Props {
  onLogin: () => void;
  loginValue: string;
  passwordValue: string;
}

const LoginPage: React.FC<Props> = ({ onLogin, passwordValue, loginValue }) => {
  // const [login, setLogin] = useState('')
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (password === passwordValue) {
      onLogin();
    } else {
      setError('Неверный логин или пароль');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <h2>Раньше здесь был сайт</h2>
        {/* <input type="text" value={login} onChange={e => setLogin(e.target.value)} placeholder='Логин' /> */}
        <input
          type="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          placeholder="Пароль"
        />
        <button onClick={handleLogin}>Войти</button>
        {error && <div className="error">{error}</div>}
      </div>
    </div>
  );
};

export default LoginPage;